<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">设置提现密码</span>
    </div>
    <el-row>
      <el-col :span="22">
        <el-form :model="passwordData" :rules="pwdFormRules" ref="passwordData" label-width="260px" style="text-align: center">
          <el-form-item label="提现密码" prop="cashOutPassword" >
            <el-input type="password" v-model="passwordData.cashOutPassword" placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkCashOutPass">
            <el-input type="password" v-model="passwordData.checkCashOutPass" placeholder="确认密码"></el-input>
          </el-form-item>
          <el-table-column>
            <el-button @click="submitCashoutPwdForm('passwordData')" size="mini" type="primary">提交</el-button>
          </el-table-column>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</div>
</template>

<script>
import {setCashOutPassowrd} from "../../api/b2cbusiness/b2c_investmoney";

export default {
name: "SetCashOutMoneyPassword",
  data(){
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordData.cashOutPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
  return{
    passwordData:{
    },
    pwdFormRules: {
      cashOutPassword: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
          message: '密码需包含数字、大小写字母、特殊符号，长度为 8 - 30位' }
      ],
      checkCashOutPass: [
        { required: true, validator: validatePass2, trigger: 'blur' }
      ]
    }
  }
  },
  methods:{
    submitCashoutPwdForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交取现密码?")
              .then(_ => {
                setCashOutPassowrd(this.passwordData)
                    .then(res=>{
                      this.$message({message: res.data, type: 'success'})
                      this.resetPwdForm(formName)
                    }).catch(err =>{
                  this.$message.error( err.message)
                })
              });
        }
      });
    },
    resetPwdForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>

</style>
